import React from "react";
import { Table } from "../UI/Table";
import { StyledNotificationTable, StyledLink } from "./styles";
import { NotificationBadge } from "./NotificationBadge";
import { useNotifications } from "./hooks/useNotifications";
import { Loader } from "../Loader/Loader";
import { Alert } from "../UI/Alert";
import { NotificationsFacet } from "./NotificationsFacet";
import { translate } from "../../utils/translations/translate";
import Button from "../UI/Button";
import moment from "moment";
import HomeIcon from '@mui/icons-material/Home';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import RefreshIcon from '@mui/icons-material/Refresh';
export const NotificationsContent = () => {
  const colDefs = [
    {
      field: "messageType",
      headerName: "Message Type",
      width: 150,
      cellRenderer: NotificationBadge,
      sortable: false,
      filter: false,
    },
    { field: "sender", headerName: "From",width:150, sortable: false, filter: false },
    { field: "message", headerName: "Subject", width:450, sortable: false, filter: false },
    { field: "date", headerName: "Recieved", width:290,sortable: true, filter: false },
  ];
  const {
    handlePaginationChange,
    isLoading,
    notiifcationsList,
    pageNumber,
    pageSize,
    toastInfo,
    totalRecords,
    handleRowSelection,
    onRefreshNotifications,
    clearSelected,
    updateNotificationReadStatus,
    selectedRows,
    gridRef,
    handleNotificationDownload,
    onRequestNotificationWithAdditonalParams,
    handleToastClose
  } = useNotifications();
 
  const handleDownload = () => {
    handleNotificationDownload();
  };
  const currentTimeString = moment(new Date()).format("MM/DD/YYYY hh:mm A");
  return (
    <StyledNotificationTable>
      {toastInfo && <Alert {...toastInfo} onToastClose={handleToastClose} />}
      <div className="subHeader">
        <h1 className="page-title">{translate("pageTitles.notifications")}</h1>
        <StyledLink to="/"><HomeIcon />{translate("pageTitles.returnToDashboard")}</StyledLink>
      </div>
      <div className="tma_notifcation_container">
        <NotificationsFacet
          onFilterTypeChange={onRequestNotificationWithAdditonalParams}
        />
        <div className="tma_notification_table">
        {notiifcationsList.length > 0 && (
        <header className="tma_notification_table_header">
          <div className="tma_notifications_actions">
            <Button
              text={translate("labels.markAsRead")}
              className="primary-outline"
              variantStyle="primary"
              type="button"
              onClick={updateNotificationReadStatus}
            />
            <Button
              text={translate("labels.removeSelected")}
              className="primary-outline"
              variantStyle="primary"
              onClick={clearSelected}
            />
            <p className={`${selectedRows.length ? 'display-text':'hide-text'}`}>{selectedRows.length} {translate('labels.recordsSelected')}</p>
          </div>

          <div className="flex-end">
            <p>
              {translate("labels.dataAsOf")} {currentTimeString}
            </p>
            <RefreshIcon onClick={onRefreshNotifications} />
            <DownloadForOfflineIcon onClick={handleDownload}/>
          </div>
        </header>
      )}
          <Table
            columns={colDefs}
            rowData={notiifcationsList}
            showPagination={true}
            currentPage={pageNumber}
            pageSize={pageSize}
            gridRef={gridRef}
            autoFit={false}
            onPaginationChange={handlePaginationChange}
            totalRecords={totalRecords}
            rowHeight={45}
            getRowClass={(params) => {
              if (params.data.status === "Unread") {
                return "ag-row-noti-unread";
              } else if (params.data.status === "Read") {
                return "ag-row-noti-read";
              }
              return "";
            }}
            onRowSelected={({ node }) => {
              const { data } = node;
              const selected = node.isSelected();
              const { id } = data;
              handleRowSelection(id, data, selected);
            }}
          />
        </div>
      </div>

      {isLoading && <Loader />}
    </StyledNotificationTable>
  );
};
